type SearchTrafficDataType = "Organic" | "Paid";
type BrandedTrafficDataType = "Branded" | "NonBranded";
export type TrafficDataType = SearchTrafficDataType | BrandedTrafficDataType;

export interface ITiersConfig {
    name: string;
    color: string;
    visible: boolean;
    id: TrafficDataType;
}

interface ITrafficGraphItem extends ITiersConfig {
    y: number;
    total?: number;
}
export enum ETrafficDistributionTypes {
    BRANDED = "BRANDED",
    SEARCH = "SEARCH",
}

export interface ITrafficTitleConfig {
    title: string;
    tooltip: string;
}

export type ITrafficTitles = Record<ETrafficDistributionTypes, ITrafficTitleConfig>;

export interface ITrafficTransformedData extends ITrafficGraphItem {
    percentage?: number;
    change?: number;
}
